import { render, staticRenderFns } from "./JoinPage.vue?vue&type=template&id=04536f8c&scoped=true"
var script = {}
import style0 from "./JoinPage.vue?vue&type=style&index=0&id=04536f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04536f8c",
  null
  
)

export default component.exports